import axios from "../api";
export const getProfile = async () => {
    const res = await axios.get("/users/profile");
    return res.data;
};
//# sourceMappingURL=getProfile.js.map